export const removeLastElement = (url) => {
    // Check if the last character is a slash
    if (url.endsWith('/')) {
      // Remove the last character
      return url.slice(0, -1);
    }
    // Return the original URL if no trailing slash
    return url;
  }
